import { render, staticRenderFns } from "./UserSnippet.vue?vue&type=template&id=15599d6a&scoped=true&"
import script from "./UserSnippet.vue?vue&type=script&lang=js&"
export * from "./UserSnippet.vue?vue&type=script&lang=js&"
import style0 from "./UserSnippet.vue?vue&type=style&index=0&id=15599d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15599d6a",
  null
  
)

export default component.exports